export const allowedRolesStarterPlan = ['admin', 'manager']
